import React, { useState } from 'react';
import '../styles/TwoFolderFlaps.css';

const TwoFolderFlaps = ({ tabs, activeTab, onTabChange, children }) => {
    const [contentKey, setContentKey] = useState(0);

    const handleTabClick = (index, event) => {
        event.preventDefault();
        if (index !== activeTab) {
            onTabChange(index);
            setContentKey(prev => prev + 1); // Force content re-render for fade animation
        }
    };

    const handleKeyDown = (index, event) => {
        if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            handleTabClick(index, event);
        } else if (event.key === 'ArrowLeft') {
            event.preventDefault();
            const newIndex = index === 0 ? tabs.length - 1 : index - 1;
            handleTabClick(newIndex, event);
        } else if (event.key === 'ArrowRight') {
            event.preventDefault();
            const newIndex = index === tabs.length - 1 ? 0 : index + 1;
            handleTabClick(newIndex, event);
        }
    };

    return (
        <div className="folder-flaps-wrapper">
            <nav className="folder-flaps-container">
                {tabs.map((tab, index) => (
                    <button
                        key={index}
                        className={`folder-flap ${activeTab === index ? 'active' : ''}`}
                        onClick={(e) => handleTabClick(index, e)}
                        onKeyDown={(e) => handleKeyDown(index, e)}
                        aria-selected={activeTab === index}
                        role="tab"
                        tabIndex={0}
                    >
                        {tab}
                    </button>
                ))}
            </nav>
            <div className="folder-content-panel">
                <div key={contentKey} className="folder-content-inner">
                    {children}
                </div>
            </div>
        </div>
    );
};

export default TwoFolderFlaps; 